export default __webpack_public_path__ + "static/media/dashboard-icon.e6c8ac29.svg";